import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ManagedInput from 'components/form/managed_input';

export default class CommissionPlanFormTier extends React.Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    readOnly: PropTypes.bool,
    tier: PropTypes.shape({
      brokerSplit: PropTypes.number,
      formattedFrom: PropTypes.string,
      to: PropTypes.number
    }).isRequired,
    unlimited: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }

  handleChange = (changes) => {
    this.props.onChange({ ...this.props.tier, ...changes }, this.props.index);
  }

  render() {
    return (
      <tr>
        <td className="numeric bg-light" name="from">
          {this.props.tier.formattedFrom}
        </td>

        <td className={classNames('numeric', { 'bg-light': this.props.unlimited || this.props.readOnly })}>
          {this.props.unlimited ? <span name="unlimited-to-label">Unlimited</span> :
            <ManagedInput
              disabled={this.props.readOnly}
              name="to"
              precision={0}
              type="currency"
              value={this.props.tier.to}
              onChange={this.handleChange}
            />
          }
        </td>

        <td className={classNames('numeric', { disabled: this.props.readOnly })}>
          <ManagedInput
            disabled={this.props.readOnly}
            name="brokerSplit"
            type="number"
            value={this.props.tier.brokerSplit == null ? '' : this.props.tier.brokerSplit}
            onChange={this.handleChange}
          />
        </td>
      </tr>
    );
  }
}
